import { TooltipDesktop } from '@cian/ui-kit';
import { IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadUserFavorites } from '../../../actions/favorites';
import { openNotificationsModal } from '../../../actions/notifications/openModal';
import { Utility as UtilityRedesign } from '../../../components/Utility/Redesign';
import { useMobileBottomNavigation } from '../../../hooks/useMobileBottomNavigation';
import { EFavoritesStatus, IFavoritesState } from '../../../types/favorites';
import { IApplicationState, TThunkDispatch } from '../../../types/redux';
import { FavoritesTooltipContainer } from '../../FavoritesTooltip';
import { trackFavoritesIconClick } from '../tracking';

export const UtilityFavoritesContainer: React.FC = () => {
  const [isMainPage, setIsMainPage] = React.useState(false);

  const dispatch = useDispatch<TThunkDispatch>();

  const favoritesLink = useSelector<IApplicationState, string | null>(state => state.servicesLinks.favorites);
  const favoritesCount = useSelector<IApplicationState, number>(state => state.favorites.count);
  const favoriteItems = useSelector<IApplicationState, IFavoritesState['favoriteItems']>(
    state => state.favorites.favoriteItems,
  );
  const favoritesStatus = useSelector<IApplicationState, EFavoritesStatus>(state => state.favorites.status);

  const isMobileBottomNavigationEnabled = useMobileBottomNavigation();

  const handleClick = React.useCallback(() => {
    trackFavoritesIconClick();
  }, []);

  const handleOpen = React.useCallback(() => {
    dispatch(openNotificationsModal(false));

    if (
      favoritesCount > 0 &&
      favoritesStatus !== EFavoritesStatus.Loading &&
      favoritesStatus !== EFavoritesStatus.Succeed
    ) {
      dispatch(loadUserFavorites());
    }
  }, [dispatch, favoritesCount, favoritesStatus]);

  React.useEffect(() => {
    // Открываем вкладку Избранного в той же, если переход с главной страницы
    setIsMainPage(window.location.pathname === '/');
  }, []);

  if (!favoritesLink || isMobileBottomNavigationEnabled) {
    return null;
  }

  return (
    <TooltipDesktop
      onOpen={handleOpen}
      placement={favoritesCount ? 'bottom-end' : 'bottom'}
      theme={favoritesCount ? 'white' : 'black'}
      title={
        favoritesCount > 0 && favoriteItems.length > 0 ? (
          <FavoritesTooltipContainer target={isMainPage ? '_self' : '_blank'} />
        ) : favoritesStatus === EFavoritesStatus.Loading ? (
          'Загружаем избранное…'
        ) : (
          'Избранное'
        )
      }
    >
      <div data-testid="utility-title" data-name="UtilityFavoritesContainer">
        <UtilityRedesign
          title="Избранное"
          icon={IconToggleHeartOff16}
          href={favoritesLink}
          onClick={handleClick}
          target={isMainPage ? '_self' : '_blank'}
          withoutTitle={true}
        />
      </div>
    </TooltipDesktop>
  );
};
